import { BitfStrapiModel } from '@common/libs/bitforce/core/models/strapi/bitf-strapi.model';
import { Brand } from './brand.model';
import { Image } from './image.model';

export class Vehicle extends BitfStrapiModel {
  model: string;
  modelCode: string;
  carBody: string;
  year: string;
  youtubeEmbed: string;
  vehicleDescription: string;

  // Relations
  brand: Brand;
  gallery: Image[];

  get youtubeEmbedUrl(): string {
    if (this.youtubeEmbed) {
      const match = this.youtubeEmbed.match(/\<iframe.+src\=(?:\"|\')(.+?)(?:\"|\')(?:.+?)>/);
      if (match && match[1]) {
        return match[1];
      }
    }
  }

  constructor(data?: any) {
    super({
      data,
      hydrateProperties: {
        brand: { model: Brand },
        gallery: { model: Image },
      },
      serializeProperties: [],
    });
  }
}
